import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { assetRootReducer } from './assetsStateEngine';
import { cmsRootReducer } from './cmsStateEngine';
import { coreRootReducer } from './coreStateEngine';
import { websiteRootReducer } from './websiteStateEngine';
import { bookingRootReducer } from './bookingStateEngine';
import { couponReducer } from './couponStateEngine';
import { optimizelyReducer } from './optimizelyStateEngine';
import { customerReducer } from './customerStateEngine';
import { overrideFetch } from './util/FetchOverride';
overrideFetch();
var enhancers = [];
var middleware = [
    thunk,
];
if (process.env.NODE_ENV !== 'production') {
    var loggerPromise = import('redux-logger');
    loggerPromise.then(function (loggerData) {
        var logger = loggerData.createLogger();
        middleware.push(logger);
    });
}
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    var devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension());
    }
}
var composedEnhancers = compose.apply(void 0, [applyMiddleware.apply(void 0, middleware)].concat(enhancers));
var rootReducer = combineReducers({
    assetState: assetRootReducer,
    cmsState: cmsRootReducer,
    coreState: coreRootReducer,
    websiteState: websiteRootReducer,
    bookingState: bookingRootReducer,
    couponState: couponReducer,
    optimizelyState: optimizelyReducer,
    customerState: customerReducer,
});
export * from './assetsStateEngine';
export * from './cmsStateEngine';
export * from './coreStateEngine';
export * from './couponStateEngine';
export * from './websiteStateEngine';
export * from './bookingStateEngine';
export * from './optimizelyStateEngine';
export * from './customerStateEngine';
export * from './util';
export * from './settings';
// pass an optional param to rehydrate state on app start
var store = createStore(rootReducer, composedEnhancers);
export { store };
